export default "__VITE_ASSET__BpKkucmL__"